enum BusinessType {
  SITTER = 'sitter',
  FACILITY = 'facility',
}

export const ALL_BUSINESS_TYPES = Object.values(BusinessType);

export default BusinessType;
